// extracted by mini-css-extract-plugin
export default {"root":"offline-activity-animation_root__Fa-Ay","layer":"offline-activity-animation_layer__hh0dv","animWrap":"offline-activity-animation_animWrap__cdHed"};